import styled from 'styled-components';

export const Container = styled.div`
  height: 1.313rem;
  padding: 0 0.5rem;
  display: inline-flex;
  align-items: center;
  border-radius: 0.25rem;
  background-color: ${({ bgColor }) => bgColor || '#666666'};
`;

export const Text = styled.span`
  font-weight: ${({ txtFontWeight }) => txtFontWeight || 'normal'};
  color: ${({ txtColor }) => txtColor || 'white'};
`;
